import type { WidgetSettingsResponse } from '@teo/widget-shared';

export const TEO_WIDGET_SETTINGS_EVENT = 'teo:widget-settings';

declare global {
  interface Window {
    __TEO_WIDGET_SETTINGS__?: WidgetSettingsResponse;
  }
}

/** Publish the settings payload from bootstrap (one GET). Playground / debug listen here — no refetch. */
export function publishWidgetSettings(settings: WidgetSettingsResponse): void {
  if (typeof window === 'undefined') return;
  window.__TEO_WIDGET_SETTINGS__ = settings;
  window.dispatchEvent(
    new CustomEvent(TEO_WIDGET_SETTINGS_EVENT, { detail: settings }),
  );
}

export function getPublishedWidgetSettings(): WidgetSettingsResponse | null {
  if (typeof window === 'undefined') return null;
  return window.__TEO_WIDGET_SETTINGS__ ?? null;
}
